import { useEffect, useLayoutEffect, useState } from 'react';
import './Services.css';
import { Box } from '@mui/material';
import ServicesSlide from '../../components/Slides/Services/ServicesSlide';
import { Helmet } from 'react-helmet';
import { BeatLoader } from 'react-spinners';

const Services = () => {
  const [isLoading, setIsLoading] = useState(true);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('color-scheme', 'dark');
  })

  useEffect(() => {
    const mediaElements = Array.from(document.querySelectorAll('img, video'));
    let loadedCount = 0;

    const checkAllLoaded = () => {
      loadedCount++;
      if (loadedCount === mediaElements.length) {
        setIsLoading(false);
      }
    };

    if (mediaElements.length === 0) {
      setIsLoading(false);
    } else {
      mediaElements.forEach((el) => {
        if (el instanceof HTMLImageElement && el.complete) {
          checkAllLoaded();
        } else if (el instanceof HTMLVideoElement && el.readyState >= 3) {
          checkAllLoaded();
        } else {
          el.addEventListener('load', checkAllLoaded);
          el.addEventListener('error', checkAllLoaded);
        }
      });
    }

    return () => {
      mediaElements.forEach((el) => {
        el.removeEventListener('load', checkAllLoaded);
        el.removeEventListener('error', checkAllLoaded);
      });
    };
  }, []);

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <BeatLoader
          color={'var(--accent-1--dark)'}
          loading={isLoading}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Services | Billet Precision Ltd.</title>
        <meta name="description" content="Explore our custom CNC machining, prototyping, and manufacturing services." />
        <meta property="og:title" content="Services | Billet Precision Ltd." />
        <meta property="og:description" content="Explore our custom CNC machining, prototyping, and manufacturing services." />
        <link rel="canonical" href="https://billetprecision.ca/services" />
      </Helmet>
      <Box className="main-content" id="services-main-content">
        <ServicesSlide />
      </Box>
    </>
  );
};


export default Services;